import Vue from 'vue'
import mainVue from './main.vue'

const defaults = {}

const MainConstructor = Vue.extend(mainVue)

let instance, currentBox

const defaultCallback = action => {
  if (currentBox) {
    let callback = currentBox.callback
    if (typeof callback === 'function') {
      callback(action, instance.callbackData)
    }
    if (currentBox.resolve) {
      if (action === 'confirm') {
        currentBox.resolve({action, data: instance.callbackData})
      } else if (currentBox.reject && (action === 'cancel' || action === 'close')) {
        currentBox.reject(action)
      }
    }
  }
}

const initInstance = () => {
  instance = new MainConstructor({
    el: document.createElement('div'),
  })

  instance.callback = defaultCallback
}

const showBox = () => {
  if (!instance) {
    initInstance()
  }

  instance.action = ''

  if (!instance.visible || instance.closeTimer) {
    if (currentBox) {
      let options = currentBox.options
      for (let prop in options) {
        if (options.hasOwnProperty(prop)) {
          instance[prop] = options[prop]
        }
      }

      if (options.callback === undefined) {
        instance.callback = defaultCallback
      }

      let oldCb = instance.callback
      instance.callback = (action, instance) => {
        oldCb(action, instance)
      }

      instance.getTableData().then(instance.setTableData)

      document.body.appendChild(instance.$el)

      Vue.nextTick(() => {
        instance.visible = true
      })
    }
  }
}

const OrderReviewHistoryBox = function (options, callback) {
  if (Vue.prototype.$isServer) return
  if (options.callback && !callback) {
    callback = options.callback
  }

  if (typeof Promise !== 'undefined') {
    return new Promise((resolve, reject) => { // eslint-disable-line
      currentBox = {
        options: _.merge({}, defaults, OrderReviewHistoryBox.defaults, options),
        callback: callback,
        resolve: resolve,
        reject: reject,
      }

      showBox()
    })
  } else {
    currentBox = {
      options: _.merge({}, defaults, OrderReviewHistoryBox.defaults, options),
      callback: callback,
    }

    showBox()
  }
}

OrderReviewHistoryBox.setDefaults = defaults => {
  OrderReviewHistoryBox.defaults = defaults
}

OrderReviewHistoryBox.open = (orderId, options = {}) => {
  return OrderReviewHistoryBox(_.merge({orderId}, options))
}

OrderReviewHistoryBox.close = () => {
  instance.doClose()
  instance.visible = false
  currentBox = null
}

OrderReviewHistoryBox.destroy = () => {
  if (instance) {
    instance.$el.remove()
    instance.$destroy()
    instance = null
  }
}

export default OrderReviewHistoryBox
export { OrderReviewHistoryBox }



// WEBPACK FOOTER //
// ./src/views/order-review/components/order-review-history-box/src/main.js